<template>
    <h1 class="heading1">Root ag(act)</h1>
    <article class="rootdec" lang="en">
        
        The root <strong>"ag"</strong> comes from the Latin verb stem <em>agere</em>, meaning <strong>"to do"</strong> or <strong>"to drive"</strong>.<br>
        The root <strong>"act"</strong> comes from the Latin participle <em>actum</em>, which also means <strong>"to do"</strong> or <strong>"to drive"</strong>.
    </article>

    <aside lang="jp">
        語根「<strong>ag</strong>」はラテン語の動詞<em>agere</em>の語幹に由来し、「<strong>行う</strong>」又は「<strong>駆り立てる</strong>」という意味があります <br>
        語根「<strong>act</strong>」は <em>agere</em> の分詞形 <em>actum</em> に由来し、同じく「<strong>行う</strong>」または「<strong>駆り立てる</strong>」という意味です。
    </aside>

    <aside lang="zh">
        词根「<strong>ag</strong>」来自拉丁语动词 <em>agere</em> 的词干部分，意思是「<strong>做</strong>」或「<strong>驱使</strong>」。<br>
      「<strong>act</strong>」来自 <em>agere</em> 的分词 <em>actum</em>，同样表示「<strong>做</strong>」或「<strong>驱使</strong>」的含义。
    </aside>
    <p></p>
    
    <div class="root">ag</div>
    <div class="root">act</div>
</template>

<style>
    article.rootdec{
        background-color: #f9f9f9;
        border-left: 5px solid #4cAF50;
        padding: 1rem;
        margin-bottom: 1rem;
        margin-top: 0px;
        font-family: 'Segoe UI', sans-serif;
    }

    .heading1{
        text-align: center;
        font-family:Verdana, Geneva,Tahoma, sans-serif;
        border-bottom: 1px solid hsl(20, 100%, 90%);
        padding-bottom: 10px;
        color: #333;
        position: sticky;
        top: 0;
        background-color: #f1f1f1;
        border-radius: 5px;
    }
  
    .root{
        border: 1px solid black;
        border-radius: 5px;
        font-weight: bold;
        font-size: 2vw;
        padding: 10px;
        background-color: azure;
        margin-bottom: 10px;
    }
</style>